// COLORS FROM https =/'/design'.axa.com/web-guidelines/color
// MAIN PALETTE
// blues
export const deepSapphire = '#0D2970';
export const axaBlue = '#103184'; // for dark text on dark background (e.g., blue background) / link hover
export const stTropaz = '#DB0011'; // button hover
export const azure = '#3054AE'; // for links
export const darkIndigo = '#6a737b'; // blue for text / backgrounds / buttons
export const indigo = '#5174CB';

// reds
export const axaRed = '#C91432';
export const flamingo = '#EC4D33'; // for red link hover
export const burntSienna = '#F07662'; // for red links

// grayscale
export const mineshaft = '#333'; // recommended gray for text
export const scorpion = '#db0011';
export const gray = '#7F7F7F';
export const dustyGray = '#999';
export const silver = '#CCC';
export const mercury = '#E5E5E5';
export const wildSand = '#F5F5F5'; // for backgrounds
export const alabaster = '#FAFAFA';
export const white = '#FFF'; // for backgrounds / buttons / text on dark backgrounds (e.g., blue background)

// SECONDARY PALETTE
// reds
export const amaranth = '#F02849'; // for cta buttons

// grayscale
export const outerSpace = '#343C3F';

// Place unrecommended colors below



// WEBPACK FOOTER //
// ./src/app/themes/axa/colors.js